import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';

const url = (termsAndConditionsId: number) => `/terms_and_conditions/${termsAndConditionsId}/pdf`;

export type UploadTermsAndConditionsPDFVariables = {
  termsAndConditionsId: number;
  pdf: File;
};

export async function uploadTermsAndConditionsPDFFn(
  axiosInstance: Promise<AxiosInstance>,
  { termsAndConditionsId, pdf }: UploadTermsAndConditionsPDFVariables,
) {
  const instance = await axiosInstance;
  const formData = new FormData();
  formData.append('pdf', pdf);

  return instance.post(url(termsAndConditionsId), formData);
}

export function useUploadTermsAndConditionsPDF() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, UploadTermsAndConditionsPDFVariables>({
    mutationFn: variables => uploadTermsAndConditionsPDFFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['termsAndConditionsSettings'] });
      client.invalidateQueries({ queryKey: ['companyConfigurationV2'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    UploadTermsAndConditionsPDFVariables,
    'uploadTermsAndConditionsPDF'
  >('uploadTermsAndConditionsPDF', mutation);
}
